<template>
  <div>
    <base-title
      title="Google Analytics"
      :subtitle="StringLanguage.integrations"
      link="integracoes"
    />

    <div class="integration-register">
      <div class="header">
        <div class="d-flex justify-between align-center w-100">
          <p class="title">Informações</p>
          <div class="toggle" @click="toggle()">
            <input type="checkbox" id="toggle-checkbox" v-model="toggleOn" />

            <div
              class="toggle-control"
              :class="toggleOn ? 'toggleOn' : 'toggleOff'"
            >
              <span class="control">
                <span>{{ toggleOn ? 'Ativado' : 'Desativado' }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="form">
        <base-input
          placeholder="ID da vista de propriedade"
          class="w-100"
          v-model="idProperty"
          :valid="registerValid.idProperty"
          @blur="validateProperty"
          @focus="registerValid.idProperty = true"
        />

        <base-input
          placeholder="ID de rastreamento"
          class="w-100"
          v-model="idTracking"
          :valid="registerValid.idTracking"
        />

        <div @click="save()" class="d-flex justify-end mt_20">
          <base-button text="Salvar" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/veasy/integrations.css';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseInput from '@/components/Input.vue';
import StoreAPI from '@/api/store';

export default {
  components: {
    BaseTitle,
    BaseButton,
    BaseInput,
  },
  data() {
    return {
      toggleOn: false,
      idProperty: '',
      idTracking: '',
      backRoute: 'google-analytics',
      registerValid: {
        idProperty: true,
        idTracking: true,
      },
    };
  },

  async created() {
    const response = await StoreAPI.storeGetConfiguration();

    const configuration = response.getData([]);

    if (configuration.analytics) {
      this.toggleOn = configuration.analytics.active;
      this.idProperty = configuration.analytics.idTracking;
      this.idTracking = configuration.analytics.idTracking;
      this.backRoute = 'integracoes';
    }
  },
  methods: {
    toggle() {
      this.toggleOn = !this.toggleOn;
    },
    validateProperty() {
      if (this.idProperty.startsWith('UA-')) {
        if (
          !(this.idProperty.split('-')[1].length == 9) &&
          !(this.idProperty.split('-')[1].length == 0)
        ) {
          this.registerValid.idProperty = false;
          return;
        }
        this.registerValid.idProperty = true;
        return;
      }
      this.registerValid.idProperty = false;
    },
    async save() {
      if (this.idProperty.length === 0 || !this.idProperty) {
        this.registerValid.idProperty = false;
        return;
      }

      if (this.idTracking.length === 0 || !this.idTracking) {
        this.registerValid.idTracking = false;
        return;
      }

      const response = await StoreAPI.storeConfiguration({
        analytics: {
          idProperty: this.idTracking,
          idTracking: this.idTracking,
          active: this.toggleOn,
        },
      });

      if (response.getErrors([]).length > 0) {
        this.registerValid.idTracking = false;
        this.registerValid.idProperty = false;
        alert('Ocorreu um error');
      }

      this.backRoute = 'integracoes';
    },
  },
};
</script>
